// src/components/works/AdvertisingContent.tsx
import React from 'react';
import {
  IntroText,
  SubHeading,
  ContentParagraph,
  EmphasisText,
  StyledList,
  StyledListItem,
  CallToActionText,
} from '../../styles/GlobalStyles';

const AdvertisingContent: React.FC = () => {
  return (
    <>
      <IntroText>
        低コストで効果的なマーケティングを желаете お客様へ
      </IntroText>
      <ContentParagraph>
        課題: SNS/GoogleMAP掲載方法、Web広告配信方法がわからない...
      </ContentParagraph>
      <ContentParagraph>
        LudyworksのWebマーケティングは、お客様と二人三脚で課題を解決します。
      </ContentParagraph>

      <SubHeading>SEO・MEOの特徴</SubHeading>
      <ContentParagraph>
        SEO: Google検索上位表示でクリック率UP。
        MEO: GoogleMap上位表示。
      </ContentParagraph>
      <StyledList>
        <StyledListItem>キーワード戦略</StyledListItem>
        <StyledListItem>高品質コンテンツ</StyledListItem>
        <StyledListItem>サイト内部構造最適化</StyledListItem>
      </StyledList>
      <ContentParagraph>
        継続的なSEO対策をお客様と並走します。
      </ContentParagraph>

      <SubHeading>インターネット広告の特徴</SubHeading>
      <StyledList>
        <StyledListItem>低予算でスモールスタート</StyledListItem>
        <StyledListItem>詳細なターゲティング</StyledListItem>
        <StyledListItem>リアルタイム効果測定</StyledListItem>
      </StyledList>
      <ContentParagraph>
        専門知識と分析・改善スキルが必要ですが、弊社の広告運用サービスがサポートします。
      </ContentParagraph>

      <SubHeading>弊社の広告サポート体制</SubHeading>
      <ContentParagraph>
        Google広告、Yahoo!広告、Meta広告、X広告、LINE広告など幅広くサポート。
        ビジネス目標に合わせ、最適な媒体選定から改善提案まで一気通貫でご支援。
      </ContentParagraph>
      <CallToActionText>まずはお気軽にお問い合わせください。</CallToActionText>
    </>
  );
};

export default AdvertisingContent;
